module.exports = __webpack_public_path__ + "static/media/person-carry.05b3fc05.svg";